// extracted by mini-css-extract-plugin
export default {"second-category-wrap":"BpnXM","second-child-item":"u0bcS","dhat":"QkRNa","img-wrap":"SzPHr","cate-img":"U27g5","cate-name":"hpm3z","no-carousel":"cqzfZ"};